import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const host = process.env.REACT_APP_BACKEND_HOST;

const InvoiceRowActions = ({ invoice, onDelete }) => {
  return (
    <div className="field is-grouped">
      {invoice.status === "PENDING" ? (
        <div className="field mr-3 mb-0">
          <div className="control">
            <Link
              className="button is-small is-primary"
              title="Completar"
              to={`/invoices/${invoice.id}`}
            >
              <FontAwesomeIcon icon={["far", "check-square"]} />
            </Link>
          </div>
        </div>
      ) : null}
      <div className="field mr-3 mb-0">
        <div className="control">
          <a
            href={`${host}api/invoices/${invoice.id}/download/`}
            className="button is-small is-primary"
            title="Descargar"
          >
            <FontAwesomeIcon icon={["fas", "download"]} />
          </a>
        </div>
      </div>
      <div className="field mb-0">
        <div className="control">
          <button
            className="button is-small is-primary"
            title="Eliminar"
            onClick={onDelete}
          >
            <FontAwesomeIcon icon={["fas", "trash"]} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceRowActions;
